import React from "react";

function ExpandIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="add">
        <path
          id="Vector"
          d="M19 13.3413H13V19.3413H11V13.3413H5V11.3413H11V5.34131H13V11.3413H19V13.3413Z"
          fill="#4A4A4A"
        />
      </g>
    </svg>
  );
}

export { ExpandIcon };
